import { APIs } from '../utils/constants';

// Function to get the current access token
const getAccessToken = () => {
  return localStorage.getItem('accessToken');
};

// Function to save the new access token
export const SaveAccessToken = (token) => {
  localStorage.setItem('accessToken', token);
};

// Function to refresh the access token
const refreshToken = async () => {
  try {
    const res = await fetch(APIs.REFRESH_TOKEN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (res.status === 401 || res.status === 403) {
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      window.location.href = '/'; // Redirect to your login page
      return null; // Return null to prevent further attempts
    }

    if (!res.ok) {
      throw new Error('Failed to refresh token');
    }

    const data = await res.json();
    const newAccessToken = data.accessToken;
    SaveAccessToken(newAccessToken);
    return newAccessToken;
  } catch (error) {
    // console.error('Token refresh failed:', error);
  }
};

export const AuthFetch = async (url, options = {}) => {
  let token = getAccessToken();
  let response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  // Check for 401 Unauthorized status
  if (response.status === 401) {
    const r = await response.json();

    if (r.error != 'Token is expired') {
      return response;
    }
    const newToken = await refreshToken();
    if (newToken) {
      // Retry the original request with the new token
      response = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          'Content-Type': 'application/json',
          Authorization: `Bearer ${newToken}`,
        },
      });
    }
  }

  return response;
};